(function () {
  var STORAGE_KEY = 'taljean_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {}
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var handles = getWishlist();
    var index = handles.indexOf(handle);
    if (index === -1) {
      handles.push(handle);
    } else {
      handles.splice(index, 1);
    }
    saveWishlist(handles);
    refreshButtons();
    updateHeaderCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: handles } }));
    return handles.indexOf(handle) !== -1;
  }

  function refreshButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    buttons.forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var active = isInWishlist(handle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateHeaderCount() {
    var bubble = document.querySelector('[data-wishlist-count]');
    if (!bubble) return;
    var count = getWishlist().length;
    bubble.textContent = count;
    bubble.hidden = count === 0;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;
    toggleWishlist(handle);
  });

  document.addEventListener('DOMContentLoaded', function () {
    refreshButtons();
    updateHeaderCount();
  });

  if (document.readyState !== 'loading') {
    refreshButtons();
    updateHeaderCount();
  }

  window.taljeanWishlist = {
    get: getWishlist,
    isInWishlist: isInWishlist,
    toggle: toggleWishlist
  };
})();
